import { render } from "./TaskC.vue?vue&type=template&id=82b1d56e&ts=true"
import script from "./TaskC.vue?vue&type=script&lang=ts"
export * from "./TaskC.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__